import { gql } from '__generated__';

export default gql(`
  mutation CompleteAuthenticatorLoginSession($input: CompleteAuthenticatorLoginSessionInput!) {
    completeAuthenticatorLoginSession(input: $input) {
      id
      user {
        ...CurrentUserFields
      }
    }
  }
`);
